<template>
  <div>
    <a-modal v-model="accepvisible" :title="typeIndex == 0? '移交': '设为库存'" width="60%" :maskClosable="false" @cancel="accepvisible=false">
				<template slot="footer" v-if="typeIndex == 0">
					<a-button key="back" @click="accepvisible=false"> 取消 </a-button>
					<a-button key="submit" type="primary" @click="transfer"> 移交 </a-button>
				</template>
                <template slot="footer" v-if="typeIndex == 1">
					<a-button key="back" @click="accepvisible=false"> 取消 </a-button>
					<a-button key="submit" type="primary" @click=" inventory"> 确定 </a-button>
				</template>
				<a-table :data-source="selectedRowKeysList" bordered :pagination="false">
                    <a-table-column key="index" title="序号" data-index="index">
							<template scope="text, record, index">{{ index+1 }}</template>
						</a-table-column>
                    <a-table-column key="asset_sn" title="物品编号" data-index="asset_sn" />
					<a-table-column key="name" title="物品名称" data-index="name" />
					<a-table-column key="model" title="规格型号" data-index="model" />
                    <a-table-column key="dept_name" title="责任部门" data-index="dept_name"  v-if="typeIndex == 1"/>
					<a-table-column key="keeper" title="保管人" data-index="keeper"  v-if="typeIndex == 1"/>
                    <a-table-column key="keeper" title="原保管人" data-index="keeper"  v-if="typeIndex == 0"/>
					<a-table-column key="deptId" title="移至部门" data-index="deptId" width="250px" v-if="typeIndex == 0">
						<template slot-scope="text, record">
							<a-tree-select allowClear :treeData="deptTree2" placeholder="请选择" v-model="record.deptId"
								@change="leaderid($event)" style="width: 200px;" treeDefaultExpandAll>
							</a-tree-select>
						</template>
					</a-table-column>
					<a-table-column key="toKeeper" title="移至保管人" data-index="toKeeper" width="220px" v-if="typeIndex == 0">
						<template slot-scope="text, record">
							<a-select show-search allowClear placeholder="保管人" class="margin_self"
								v-model="record.toKeeper" style="width: 170px">
								<a-select-option :value="item.userName" v-for="(item, index) in userplainOptions"
									:key="index">
									{{ item.userName }}
								</a-select-option>
							</a-select>
						</template>
					</a-table-column>
                    <a-table-column key="index" title="移交人" data-index="index"  v-if="typeIndex == 0">
						<template slot-scope="text">
							{{ $store.state.user.info.userName }}
						</template>
					</a-table-column>
					<a-table-column key="action" title="操作" data-index="action" width="150px">
						<template scope="text,record,index">
							<a @click="removeTo(index,record)">删除</a>
						</template>
					</a-table-column>
				</a-table>
			</a-modal>
  </div>
</template>

<script>
	import { getUserList } from '@/api/system'
	import { tree_all } from '@/api/purchase'
    import { transferOther , transferStock} from '@/api/assetmenag'
export default {
    data() {
        return {
            typeIndex: undefined,
            accepvisible: false,
            selectedRowKeysList: [],
            deptTree2: [],
            userplainOptions: [],
            companyList: [],
            record: {
                deptId: undefined,
                toKeeper: undefined

            }

        }
    },
    methods: {
        init (data) {
           this.$nextTick( ( ) => {
             console.log(data, 'data===================')
            //获取当前公司部门
            this.getCompany()
            this.selectedRowKeysList = JSON.parse(JSON.stringify(data.selectedRows))
            this.typeIndex = data.typeIndex
            this.accepvisible = true
           })
            

        },
        //删除
        removeTo(index,record) {
           this.selectedRowKeysList.splice(index, 1)

        },
        //获取当前公司部门
        getCompany() {
            tree_all().then(res=>{
				this.companyList = res.data[0]
                this.companyList.forEach(item => {
                    if(item.deptId == this.$store.state.user.info.companyId) {
                        this.deptTree2 = item.children
                        console.log( this.deptTree2)
                    }

                })
			})

        },
        //获取当前部门人
        leaderid(e) {
            // 获取当前部门的人员信息
				getUserList({
					deptId: e
				}).then(res => {
					if(res.code == 200){
						this.userplainOptions = res.rows
					} else {
						this.$message.error(res.msg)
					}
				})

        },
        //设为库存
         inventory() {
            var list = []
             this.selectedRowKeysList.forEach(item => {
            var data = {
                 id: item.id,
                name: item.name,
                oldDept: item.dept_id,
                keeper: item.keeper ,
            }
            list.push(data)
           })

            transferStock({
                list: list
            }).then(res => {
                if(res.code == 200) {
                    this.accepvisible = false
                    this.$message.success(res.msg)
                    this.$emit('refresh')
                } else {
                    this.$message.error(res.msg)

                }
                
            })

         },
        //移交
        transfer() {
            var list = []
            var type = 1
           this.selectedRowKeysList.forEach(item => {
            var data = {
                 id: item.id,
                name: item.name,
                oldKeeper: item.keeper,
                toKeeper: item.toKeeper ,
                departmentId: item.deptId 
            }
            list.push(data)
            //移交前校验
            if(item.deptId == undefined || item.deptId  == '') {
                this.$message.warning('移至部门为必填项！')
            } else {
                if(item.toKeeper == undefined || item.toKeeper  == '') {
                this.$message.warning('移至保管人为必填项！')
                
            } else {
                type = 0

            }
            } 
           })
           if( type == 0) {
             transferOther({list: list}).then(res => {
                if(res.code == 200) {
                    this.accepvisible = false
                    this.$message.success(res.msg)
                    this.$emit('refresh')
                }else {
                    this.$message.error(res.msg)
                }
                console.log(res, 'res=============================')
            })

           }
           

        }
    }

}
</script>

<style>

</style>